import { random, times } from '@sama/micro-dash';
import { TagLibraryAnswer } from '../../team-apis/otterdam/answers/tag-library-answer';
import { TagLibraryOutput } from '../../team-apis/otterdam/outputs/tag-library-output';
import { OutputHelper } from './output-helper';

export class TagLibraryOutputHelper extends OutputHelper<
  TagLibraryOutput,
  TagLibraryAnswer
> {
  override getLabelFor(answer: TagLibraryAnswer | undefined) {
    return answer ? answer.join('; ') : '';
  }

  override makeRandomAnswer() {
    return times(random(5), () => Math.random().toString());
  }

  override getBlankAnswer() {
    return [];
  }
}
